interface Props {
  fluid?: boolean;
  size?: 'large' | 'small' | null;
  showButtons?: boolean;
  invalid?: boolean;
}

interface Context {
  disabled?: boolean;
  filled?: boolean;
}

interface Parent {
  instance: {
    $name: string;
  };
}

export default {
  root: ({ props, context, parent }: { props: Props; context: Context; parent: Parent }) => ({
    class: [
      // Font
      'leading-[normal]',

      // Flex
      { 'flex-1 w-[1%]': parent.instance.$name === 'InputGroup' },

      // Spacing
      'm-0',
      'w-full',

      // Size
      {
        'px-4 py-4': props.size === 'large',
        'px-2 py-2': props.size === 'small',
        'p-4': props.size === null,
      },

      // Shape
      { 'rounded-md': parent.instance.$name !== 'InputGroup' },
      {
        'first:rounded-l-md rounded-none last:rounded-r-md': parent.instance.$name === 'InputGroup',
      },
      { 'border-0 border-y border-l last:border-r': parent.instance.$name === 'InputGroup' },
      { 'first:ml-0 -ml-px': parent.instance.$name === 'InputGroup' && !props.showButtons },

      // Colors
      'text-neutral-700',
      'placeholder:text-neutral-400',
      'bg-white',
      'border',
      { 'border-neutral-200': !props.invalid },

      // Invalid State
      'invalid:focus:ring-red-200',
      'invalid:hover:border-red-500',
      { 'border-red-500': props.invalid },

      // States
      {
        'hover:border-neutral-300': !context.disabled && !props.invalid,
        'focus:outline-none focus:outline-offset-0 input-focus focus:z-10': !context.disabled,
        'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
      },

      // Filled State *for FloatLabel
      { filled: parent.instance?.$name === 'FloatLabel' && context.filled },

      // Misc
      'appearance-none',
      'transition-colors transition-shadow duration-200',
    ],
  }),
};
